export const reviews = [
  {
    profileImage: {
      url: 'https://www.datocms-assets.com/10154/1657618590-boy2.svg',
      alt: 'boy2',
    },
    reviewContent:
      '“Top notch product. What a excellent product for the price. Not cheap looking and nice quality equipment. Installing is a breeze. 👍👍”',
    reviewDate: '05.02.20',
    reviewerName: 'Rafael T.',
    customData: '{\n  "categories": [\n    "quality"\n  ]\n}',
    id: 'DatoCmsReview-147537926',
  },
  {
    profileImage: {
      url: 'https://www.datocms-assets.com/10154/1657618612-boy3.svg',
      alt: 'boy3',
    },
    reviewContent:
      '“I am very impressed with the quality and price/value of the product... I just wish I had the option to give them more than 5 stars. I couldn’t have gotten a better security system.”',
    reviewDate: '04.24.20',
    reviewerName: 'Thomas C.',
    customData: '{\n  "categories": [\n    "quality"\n  ]\n}',
    id: 'DatoCmsReview-147537927',
  },
  {
    profileImage: {
      url: 'https://www.datocms-assets.com/10154/1657618636-boy4.svg',
      alt: 'boy4',
    },
    reviewContent:
      '“I recommend Cove to everyone. At my previous house I had a high end alarm system which I paid about 10 times the cost of this system and it is every bit as good as it was.”',
    reviewDate: '08.04.20',
    reviewerName: 'Phillip B.',
    customData: '{\n  "categories": [\n    "quality"\n  ]\n}',
    id: 'DatoCmsReview-147537928',
  },
  {
    profileImage: {
      url: 'https://www.datocms-assets.com/10154/1657618567-boy1.svg',
      alt: 'boy1',
    },
    reviewContent:
      '“It was easy to set up, worked immediately. I love this system”',
    reviewDate: '07.15.20',
    reviewerName: 'Benjamin N.',
    customData: '{\n  "categories": [\n    "installation"\n  ]\n}',
    id: 'DatoCmsReview-147537929',
  },
  {
    profileImage: {
      url: 'https://www.datocms-assets.com/10154/1657618762-girl1.svg',
      alt: 'girl1',
    },
    reviewContent:
      '“I don’t like strangers in my home so the self-installation was a big attraction for me. When I set it up, it genuinely was as easy as the video they made.”',
    reviewDate: '07.15.20',
    reviewerName: 'Constance U.',
    customData: '{\n  "categories": [\n    "installation"\n  ]\n}',
    id: 'DatoCmsReview-147537930',
  },
  {
    profileImage: {
      url: 'https://www.datocms-assets.com/10154/1657618787-girl2.svg',
      alt: 'girl2',
    },
    reviewContent:
      '“The hardest part was taking my old 15 year alarm system down… Very easy to use. Much easier than my old alarm system and a lot smaller. I am a 73 year old woman so if I can install it anyone can.”',
    reviewDate: '08.02.20',
    reviewerName: 'Jeannette',
    customData: '{\n  "categories": [\n    "installation"\n  ]\n}',
    id: 'DatoCmsReview-147537931',
  },
  {
    profileImage: {
      url: 'https://www.datocms-assets.com/10154/1657618810-girl3.svg',
      alt: 'girl3',
    },
    reviewContent:
      '“After successful activation, we called customer care with a few extra questions. Jeric was extremely professional, knowledgeable, and kind in dealing with all of our questions.”',
    reviewDate: '08.10.20',
    reviewerName: 'Darlene C.',
    customData: '{\n  "categories": [\n    "customer-service"\n  ]\n}',
    id: 'DatoCmsReview-147537932',
  },
  {
    profileImage: {
      url: 'https://www.datocms-assets.com/10154/1657618835-girl4.svg',
      alt: 'girl4',
    },
    reviewContent:
      "“The service is exceptional, its old school customer service which is unexpected in todays world.  I appreciate the service 100%, the customer service 100% I'M VERY HAPPY”",
    reviewDate: '08.04.20',
    reviewerName: 'Linda H.',
    customData: '{\n  "categories": [\n    "customer-service"\n  ]\n}',
    id: 'DatoCmsReview-147537933',
  },
  {
    profileImage: {
      url: 'https://www.datocms-assets.com/10154/1657618660-boy5.svg',
      alt: 'boy5',
    },
    reviewContent:
      '“If you want to be treated as a valuable customer and not as someone the customer service rep just wants to get off the call so that their time on call average jumps higher, then Cove is for you.”',
    reviewDate: '07.24.20',
    reviewerName: 'Proud M.',
    customData: '{\n  "categories": [\n    "customer-service"\n  ]\n}',
    id: 'DatoCmsReview-147537934',
  },
  {
    profileImage: {
      url: 'https://www.datocms-assets.com/10154/1657618688-boy6.svg',
      alt: 'boy6',
    },
    reviewContent:
      '“Cove has been great! It’s very affordable. It was a quick set up and very user friendly! I’ve recommended it to everyone I know!”',
    reviewDate: '07.23.20',
    reviewerName: 'Randie R.',
    customData: '{\n  "categories": [\n    "price"\n  ]\n}',
    id: 'DatoCmsReview-147537935',
  },
  {
    profileImage: {
      url: 'https://www.datocms-assets.com/10154/1657618707-boy7.svg',
      alt: 'boy7',
    },
    reviewContent:
      '“The service was awesome and the prices are the best I have seen yet for what you get and the security was put together and working in minutes...I am recommending all my friends.”',
    reviewDate: '06.17.20',
    reviewerName: 'Prof. Allen',
    customData: '{\n  "categories": [\n    "price"\n  ]\n}',
    id: 'DatoCmsReview-147537936',
  },
  {
    profileImage: {
      url: 'https://www.datocms-assets.com/10154/1657618732-boy8.svg',
      alt: 'boy8',
    },
    reviewContent:
      '“An Affordable Piece of Mind Security Solution. I highly recommend Cove for anyone looking to protect their home that wants an easy to use system with polite and knowledgeable support.”',
    reviewDate: '06.13.20',
    reviewerName: 'John K.',
    customData: '{\n  "categories": [\n    "price"\n  ]\n}',
    id: 'DatoCmsReview-147537937',
  },
];
